import PayByLinkRequiredFields from '@engine/features/virtual_terminal/vt_update_pay_by_link_required_fields';
import VtTerminalSelect from '@engine/lib/utility/vt/terminal_select';
import { handleBirthDateFields } from '@engine/features/virtual_terminal/vt_handle_birth_date';
import { toggleRequiredAttributes } from '@engine/lib/utility/toggle_required_attributes';

function makeFieldRequired(fieldId) {
  $('label[for=' + fieldId + ']').addClass('required');
}

function makeFieldNotRequired(fieldId) {
  $('label[for=' + fieldId + ']').removeClass('required');
}

function makeDivVisible(divId) {
  $('#' + divId).removeClass('hidden');
}

function makeDivHidden(divId) {
  $('#' + divId).addClass('hidden');
}

function updateDecimalAmountFor(exponent) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return ($("#".concat(prefix, "decimal_amount")).val() + '0000').substring(0, exponent);
} // eslint-disable-next-line complexity


export function updateRequiredFields(updateData) {
  var _updateData$features, _updateData$features$;

  var terminal = updateData.terminal;
  var trxType = updateData.transaction_type;
  var supportsSplitPayments = terminal.features.supports_split_payments;
  var supportsRemainingAmount = trxType.with_remaining_amount && trxType.with_required_reference_id;

  if (terminal.required_fields.with_dynamic_descriptor_fields) {
    $('#dynamic_descriptor_params').removeClass('hidden');
  } else {
    $('#dynamic_descriptor_params').addClass('hidden');
  }

  if (trxType.with_required_reference_id || supportsSplitPayments) {
    $('#reference_transaction_params').removeClass('hidden');
  } else {
    $('#reference_transaction_params').addClass('hidden');
  }

  if (supportsRemainingAmount || supportsSplitPayments) {
    $('#remaining_amount_params').removeClass('hidden');
  } else {
    $('#remaining_amount_params').addClass('hidden');
  }

  if (terminal.required_fields.with_birth_date_fields) {
    $('#birth_date_params').addClass('with-birth-date');
    handleBirthDateFields();
  } else {
    $('#birth_date_params').addClass('hidden').removeClass('with-birth-date');
  }

  if (terminal.required_fields.with_shipping_address_fields) {
    $('#shipping-address-wrapper').removeClass('hidden');
  } else {
    $('#shipping-address-wrapper').addClass('hidden');
  }

  var beneficiaryParamsRequired = terminal.required_fields.with_beneficiary_params;

  if (beneficiaryParamsRequired) {
    makeDivVisible('beneficiary_account_number');
    makeDivVisible('beneficiary_bank_code');
    makeDivVisible('beneficiary_name');
  } else {
    makeDivHidden('beneficiary_account_number');
    makeDivHidden('beneficiary_bank_code');
    makeDivHidden('beneficiary_name');
  }

  ['beneficiary_bank_code', 'beneficiary_account_number', 'beneficiary_name'].forEach(function (param) {
    toggleRequiredAttributes($("#".concat(param)).find('input'), beneficiaryParamsRequired);
  });
  /*
   * Do not toggle the required attribute directly for the required API param fields
   * when PBL form is used.
   *
   * For PBL - add only the class (a mark) needed in order to toggle the req. attr when
   * the transaction types are selected (if needed, currently only for the express checkouts).
   */

  if (VtTerminalSelect.exists()) {
    $.each(updateData.fields, function (key, field) {
      var $label = $('label[for*=' + field.label + ']');
      var $visible_input = $('input[id$="' + field.label + '"]:visible');

      if (field.required) {
        $label.addClass('required');
        $visible_input.attr('required', true);
      } else {
        $label.removeClass('required');
        $visible_input.prop('required', false);
      }
    });
  } else {
    PayByLinkRequiredFields.markAsRequired(updateData.fields);
  }

  var exponent = updateData.exponent;
  var updatedDecimalAmount = updateDecimalAmountFor(exponent);
  $('#decimal_amount').val(updatedDecimalAmount);
  $('#decimal_amount').attr('maxlength', exponent);

  if (updateData !== null && updateData !== void 0 && (_updateData$features = updateData.features) !== null && _updateData$features !== void 0 && (_updateData$features$ = _updateData$features.configure_new_managed_recurring) !== null && _updateData$features$ !== void 0 && _updateData$features$.visible) {
    $('#managed_recurring_decimal_amount').val(updateDecimalAmountFor(exponent, 'managed_recurring_')).attr('maxlength', exponent);
  }
}
var RequiredFields = {
  updateRequiredFields: updateRequiredFields,
  makeFieldRequired: makeFieldRequired,
  makeFieldNotRequired: makeFieldNotRequired,
  makeDivVisible: makeDivVisible,
  makeDivHidden: makeDivHidden
};
export default RequiredFields;